import React, { useState, useEffect, forwardRef } from 'react';
import Logo from 'Components/Logo/Logo';
import { Grid, Box } from '@material-ui/core';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';

import TableRow from '@material-ui/core/TableRow';

import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    Slide
} from '@material-ui/core';

import { commonStyle } from 'Components/CustomMaterialStyleSheets/CommonStyleSheet';
import { withStyles } from '@material-ui/core/styles';
import CommonPrint from 'Components/Print/CommonPrint';
import jsPDF from 'jspdf';
import { LOGO_URL, CLIENT_NAME } from 'Config';
import NSDL_BANK_LOGO from 'Assets/Images/NSDL_BANK_LOGO.png';
const Transition = forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

const StyledTableCell = withStyles((theme) => ({
    body: {
        fontSize: 16,
        fontWeight: 'bold'
    }
}))(TableCell);
const ValueTableCell = withStyles((theme) => ({
    body: {
        fontSize: 16,
        fontWeight: 'bold',
        color: 'green'
    }
}))(TableCell);

export function PayoutPrintNew({
    isOpen,
    title,
    request,
    positiveButtonTitle,
    positiveButtonClick,
    negativeButtonTitle,
    negativeButtonClick
}) {
    const [open, setOpen] = useState(isOpen);
    const classes = commonStyle();

    const handleNegativeButtonClick = () => {
        setOpen(false);
        negativeButtonClick();
    };
    const handlePositiveA4ButtonClick = () => {
        let pageSize = 'A4';
        CommonPrint(pageSize);
        positiveButtonClick(request);
    };
    const handlePositiveA5ButtonClick = () => {
        let pageSize = 'A5';
        CommonPrint(pageSize);
        positiveButtonClick(request);
    };

    const handlePositiveDownlaodButtonClick = () => {
        const printElement = document.getElementById('DialogPrint');
        const originalHTML = printElement.innerHTML;
     
        const sanitizedHTML = originalHTML
            .replace(/₹/g, 'Rs.')
            .replace(/[^\x00-\x7F]/g, ''); 
        printElement.innerHTML = sanitizedHTML;
       
        const doc = new jsPDF({
            orientation: 'portrait',
            unit: 'pt',
            format: 'a4',
            putOnlyUsedFonts: true,
            floatPrecision: 16
        });
        doc.html(printElement, {
            callback: function (doc) {
               
                printElement.innerHTML = originalHTML;
                
                doc.setTextColor(0, 0, 0);
                doc.setFontSize(10);
                doc.text(
                    'This is a system-generated receipt.',
                    40,
                    doc.internal.pageSize.height - 40
                );
                doc.save('Payout_Receipt.pdf');
            },
            x: 10,
            y: 40,
            width: 500,
            windowWidth: 500,
            html2canvas: {
                scale: 0.8,
                useCORS: true,
                backgroundColor: '#FFFFFF',
                allowTaint: false,
                letterRendering: true
            }
        });
    };

    const getStatusColor = (status) => {
        switch (status?.toLowerCase()) {
            case 'success':
                return 'green';
            case 'failed':
            case 'failure':
            case 'refund':
                return 'red';
            case 'pending':
            case 'process':
                return 'orange';
            default:
                return 'orange';
        }
    };

    return (
        <Grid container spacing={1}>
            <Grid item xs={12} sm={12} md={6} lg={6}>
                <Dialog
                    classes={{ paperFullScreen: 'prePrint' }}
                    // fullScreen
                    open={open}
                    onClose={() => {
                        setOpen(false);
                        negativeButtonClick(false);
                    }}
                    TransitionComponent={Transition}
                >
                    <DialogTitle
                        id="alert-dialog-title"
                        className={classes.title}
                        style={{
                            backgroundColor: getStatusColor(request.Status),
                            color: '#fff'
                        }}
                    >
                        {title}
                    </DialogTitle>
                    <DialogContent>
                        <DialogContentText id="DialogPrint">
                            <Confirmation request={request} />
                        </DialogContentText>
                    </DialogContent>
                    <Box
                        style={{
                            position: 'relative',
                            width: '100%',
                            zIndex: 0,
                            marginBottom: '16px',
                            padding: '10px',
                            backgroundColor: '#ccc',
                            color: '#000',
                            fontSize: '10px',
                            textAlign: 'center'
                        }}
                    >
                        This is a system-generated receipt.
                    </Box>
                    <DialogActions displayPrint="none">
                        <Grid container spacing={1}>
                            <Grid item xs={12} sm={12} md={3} lg={3}>
                                <Button
                                    onClick={handleNegativeButtonClick}
                                    className={
                                        classes.CustomSecondaryButtonStylePopup
                                    }
                                >
                                    {negativeButtonTitle
                                        ? negativeButtonTitle
                                        : 'Close'}
                                </Button>
                            </Grid>
                            <Grid item xs={12} sm={12} md={3} lg={3}>
                                <Button
                                    onClick={handlePositiveDownlaodButtonClick}
                                    className={
                                        classes.CustomPrimaryButtonStylePopup
                                    }
                                >
                                    {positiveButtonTitle
                                        ? positiveButtonTitle
                                        : 'Download'}
                                </Button>
                            </Grid>
                            <Grid item xs={12} sm={12} md={3} lg={3}>
                                <Button
                                    onClick={handlePositiveA4ButtonClick}
                                    className={
                                        classes.CustomPrimaryButtonStylePopup
                                    }
                                >
                                    {positiveButtonTitle
                                        ? positiveButtonTitle
                                        : 'A4 Print'}
                                </Button>
                            </Grid>
                            <Grid item xs={12} sm={12} md={3} lg={3}>
                                <Button
                                    onClick={handlePositiveA5ButtonClick}
                                    className={
                                        classes.CustomPrimaryButtonStylePopup
                                    }
                                >
                                    {positiveButtonTitle
                                        ? positiveButtonTitle
                                        : 'A5 Print'}
                                </Button>
                            </Grid>
                        </Grid>
                    </DialogActions>
                </Dialog>
            </Grid>
        </Grid>
    );
}

const Confirmation = (request) => {
                                      useEffect(() => {
                                          fetchCName();

                                          fetchLogoURL();
                                      }, []);

                                      const [logoURL, setLogoURL] = useState(
                                          ''
                                      );

                                      async function fetchLogoURL() {
                                          setLogoURL(await LOGO_URL());
                                      }

                                      const [cName, setCName] = useState('');
                                      async function fetchCName() {
                                          setCName(await CLIENT_NAME());
                                      }
                                      const NsdlBankLogo = () => {
                                          return (
                                              <img
                                                  src={NSDL_BANK_LOGO}
                                                  width={200}
                                                  alt="DMT"
                                              />
                                          );
                                      };

                                      const ReceiptLogo = () => {
                                          return (
                                              <img
                                                  src={logoURL}
                                                  width={100}
                                                  alt="DMT"
                                              />
                                          );
                                      };

                                      let data = request.request;

                                      const transactionDetails = [
                                          {
                                              label: 'Date & Time',
                                              value: data.DOC ?? 'NA'
                                          },
                                          {
                                              label: 'Product Name',
                                              value: data.ServiceName ?? 'NA'
                                          },
                                          {
                                              label: 'Payment Mode',
                                              value: data.PaymentMode ?? 'NA'
                                          },
                                          {
                                              label: 'Amount (₹)',
                                              value: data.Amount ?? '0'
                                          },
                                          {
                                              label: 'Charge (₹)',
                                              value: data.Charge ?? '0'
                                          },
                                          {
                                              label: 'GST (₹)',
                                              value: data.GST ?? '0'
                                          },
                                          {
                                              label: 'Total Amount (₹)',
                                              value: data.TotalAmount ?? '0'
                                          },
                                          {
                                              label: 'Transaction ID',
                                              value: data.TransactionID ?? '0'
                                          },
                                          {
                                              label: 'UTR No/RRN',
                                              value: data.ReferenceNo
                                          },
                                          {
                                              label: 'Beneficiary Name',
                                              value: data.DMT_BeneficiaryName
                                          },
                                          {
                                              label: 'Beneficiary Bank Name',
                                              value: data.BankName
                                          },
                                          {
                                              label: 'Beneficiary A/C Number',
                                              value: data.ConsumerNumber
                                          },
                                          {
                                              label: 'Beneficiary IFSC',
                                              value: data.IFSC
                                          },
                                          ...(data.Status.toLowerCase() ===
                                          'FAILURE'.toLowerCase()
                                              ? [
                                                    {
                                                        label: 'Failure Reason',
                                                        value: data.Description
                                                    }
                                                ]
                                              : [])
                                      ];

                                      const getStatusColor = (status) => {
                                          switch (status?.toLowerCase()) {
                                              case 'success':
                                                  return 'green';
                                              case 'failed':
                                              case 'failure':
                                                  return 'red';
                                              case 'pending':
                                              case 'process':
                                                  return 'orange';
                                              default:
                                                  return 'orange';
                                          }
                                      };
                                      return (
                                          <Grid item xs={12}>
                                              <Grid item xs={12}>
                                                  <Box
                                                      style={{
                                                          border:
                                                              '2px solid #000',
                                                          padding: '5px',
                                                          marginTop: '5px',
                                                          marginLeft: '5px',
                                                          backgroundColor:
                                                              '#fff',
                                                          width: '450px',
                                                          height: 'auto',
                                                          position: 'relative',
                                                          paddingTop: '15px'
                                                      }}
                                                  >
                                                      <Grid
                                                          style={{
                                                              display: 'flex',
                                                              justifyContent:
                                                                  'space-between',
                                                              flex: 'auto'
                                                          }}
                                                      >
                                                          <NsdlBankLogo />
                                                          <ReceiptLogo />
                                                      </Grid>
                                                      <TableContainer>
                                                          <h4
                                                              style={{
                                                                  textAlign:
                                                                      'center',
                                                                  padding:
                                                                      '10px 0',
                                                                  paddingTop:
                                                                      '40px'
                                                              }}
                                                          >
                                                              Transaction
                                                              Details
                                                          </h4>

                                                          <TableContainer>
                                                              <Table>
                                                                  <TableBody>
                                                                      <TableRow>
                                                                          <StyledTableCell
                                                                              style={{
                                                                                  padding:
                                                                                      '8px 0 8px 15px'
                                                                              }}
                                                                          >
                                                                              Transaction
                                                                              Status
                                                                          </StyledTableCell>
                                                                          <StyledTableCell
                                                                              style={{
                                                                                  padding:
                                                                                      '8px 0 8px 15px'
                                                                              }}
                                                                          >
                                                                              <span
                                                                                  style={{
                                                                                      fontSize:
                                                                                          '14px',
                                                                                      color: getStatusColor(
                                                                                          data.Status
                                                                                      ),
                                                                                      fontWeight:
                                                                                          'normal',
                                                                                      marginLeft:
                                                                                          '8px',
                                                                                      paddingLeft:
                                                                                          '25px'
                                                                                  }}
                                                                              >
                                                                                  <b>
                                                                                      {' '}
                                                                                      {data.Status ??
                                                                                          'NA'}
                                                                                  </b>
                                                                              </span>
                                                                          </StyledTableCell>
                                                                      </TableRow>
                                                                      {transactionDetails.map(
                                                                          (
                                                                              detail,
                                                                              index
                                                                          ) => (
                                                                              <TableRow
                                                                                  key={
                                                                                      index
                                                                                  }
                                                                              >
                                                                                  <StyledTableCell
                                                                                      style={{
                                                                                          padding:
                                                                                              '8px 0 8px 15px'
                                                                                      }}
                                                                                  >
                                                                                      {
                                                                                          detail.label
                                                                                      }
                                                                                  </StyledTableCell>
                                                                                  <StyledTableCell
                                                                                      style={{
                                                                                          padding:
                                                                                              '8px 0 8px 15px'
                                                                                      }}
                                                                                  >
                                                                                      <span
                                                                                          style={{
                                                                                              fontSize:
                                                                                                  '14px',
                                                                                              color:
                                                                                                  '#000',
                                                                                              fontWeight:
                                                                                                  'normal'
                                                                                          }}
                                                                                      >
                                                                                          {
                                                                                              detail.value
                                                                                          }
                                                                                      </span>
                                                                                  </StyledTableCell>
                                                                              </TableRow>
                                                                          )
                                                                      )}
                                                                  </TableBody>
                                                              </Table>
                                                          </TableContainer>
                                                      </TableContainer>
                                                  </Box>
                                              </Grid>
                                          </Grid>
                                      );
                                  };

